// Integration code snippets for each type

export function getSnippetLabels() {
  return {
    websocket: 'WebSocket',
    url: 'URL Redirect',
    callback: 'Callback',
    cookie: 'Cookie',
  };
}

export async function getIntegrationSnippet(type, params = {}) {
  const {
    appId = 3,
    apiServer = 'local-api.actual.video',
    callbackUrl = 'https://yourapp.com/callback',
    cookieName = 'polyguard_jwt',
    redirectUrl = '',
    requiredProofs = ["Full Name"],
    language = 'node',
  } = params;

  // Path to snippet file using raw-loader
  let code;
  try {
    const snippet = await import(`!!raw-loader!./${language}/${type}.snippet`);
    code = snippet.default;
  } catch (e) {
    return {
      label: 'Unknown',
      language: 'text',
      code: '// Unknown integration type or language',
    };
  }

  // Replace template variables in code
  if (typeof code === 'string') {
    code = code
      .replace(/\${appId}/g, appId)
      .replace(/\${apiServer}/g, apiServer)
      .replace(/\${callbackUrl}/g, callbackUrl)
      .replace(/\${cookieName}/g, cookieName)
      .replace(/\${redirectUrl}/g, redirectUrl)
      .replace(/\${requiredProofs}/g, Array.isArray(requiredProofs) ? requiredProofs.map(p => `"${p}"`).join(', ') : requiredProofs);
  }

  // Set label and language
  const labelMap = {
    websocket: 'WebSocket',
    url: 'URL Redirect',
    callback: 'Callback',
    cookie: 'Cookie',
  };
  const extMap = {
    node: 'javascript',
    javascript: 'html',
  };

  return {
    label: `${labelMap[type] || type} (${language === 'node' ? 'Node' : 'Browser'})`,
    language: extMap[language] || 'text',
    code,
  };
}

export const INTEGRATION_TYPES = ['websocket', 'url']; //, 'callback', 'cookie'];
export const INTEGRATION_TYPE_TO_INDEX = INTEGRATION_TYPES.reduce((acc, type, idx) => { acc[type] = idx; return acc; }, {});
export const INDEX_TO_INTEGRATION_TYPE = INTEGRATION_TYPES.reduce((acc, type, idx) => { acc[idx] = type; return acc; }, {}); 